export default __webpack_public_path__ + "static/media/nodejs.f5ef0599.png";